import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import Button from "components/Button";
import { Board, PageTop, Title, TitleArea } from "components/LayoutParts";
import Loading from "components/Loading";
import { useFindAllSystemNotifications } from "pages/AtPort/api/useFindAllSystemNotifications";
import DataTable from "pages/AtPort/SystemNotification/DataTable";
import { jumpUpToElement } from "utils/animationUtils";

const ButtonWrap = styled.div`
  margin-left: auto;
`;

const Margin = styled.div`
  margin-top: 16px;
`;

const SystemNotification = () => {
  const [totalPages, setTotalPages] = useState<number>(1);
  const [pageOption, setPageOption] = useState<AtPortPageOption>({
    after: "",
    before: "",
    pageIndex: 1,
  });

  const navigate = useNavigate();
  const { data } = useFindAllSystemNotifications({
    query: {
      pageSize: 25,
      after: pageOption?.after,
      before: pageOption?.before,
    },
  });

  const notifications = data?.data ?? [];

  const onClickCompanyAdd = () => {
    navigate("/at_port/system_notification/create");
  };

  useEffect(() => {
    setTotalPages(data?.pagination?.totalPages ?? 1);
    return () => {
      jumpUpToElement("root");
    };
  }, [data]);

  return (
    <Board>
      <PageTop />
      <TitleArea>
        <Title>お知らせ</Title>
        <ButtonWrap>
          <Button label="お知らせを作成" onClick={onClickCompanyAdd} type="primary" />
        </ButtonWrap>
      </TitleArea>
      <Margin />
      {notifications && data ? (
        <DataTable
          notificationList={notifications}
          totalPages={totalPages}
          pagination={data.pagination}
          pageOption={pageOption}
          setPageOption={setPageOption}
        />
      ) : (
        <Loading />
      )}
    </Board>
  );
};

export default SystemNotification;
